var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoProfilePictureCustomBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 92,
    height: 92,
    rx: 46,
    stroke: "#05446A",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2482_1281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0047 59.0803C58.9762 59.0803 67.9449 50.1116 67.9449 39.1401C67.9449 28.1686 58.9762 19.2 48.0047 19.2C37.0332 19.2 28.0647 28.1686 28.0647 39.1401C28.0647 50.1116 37.0334 59.0803 48.0047 59.0803Z",
    fill: "#05446A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2256 75.0148C81.7031 73.7087 81.0066 72.4897 80.2229 71.3577C76.2174 65.4365 70.0352 61.5182 63.0692 60.5603C62.1986 60.4733 61.2407 60.6473 60.5441 61.1698C56.8869 63.8692 52.5332 65.2623 48.0052 65.2623C43.4772 65.2623 39.1236 63.8692 35.4664 61.1698C34.7697 60.6473 33.8119 60.3862 32.9412 60.5603C25.9752 61.5182 19.7059 65.4365 15.7876 71.3577C15.0039 72.4897 14.3072 73.7958 13.7849 75.0148C13.5237 75.5373 13.6107 76.1468 13.8719 76.6693C14.5686 77.8883 15.4392 79.1075 16.2229 80.1523C17.4419 81.8068 18.7481 83.287 20.2284 84.6801C21.4474 85.8991 22.8406 87.0311 24.2339 88.1631C31.1127 93.3006 39.3849 95.9998 47.9182 95.9998C56.4516 95.9998 64.7237 93.3005 71.6026 88.1631C72.9957 87.1183 74.3889 85.8991 75.6081 84.6801C77.0012 83.287 78.3944 81.8066 79.6136 80.1523C80.4842 79.0203 81.2681 77.8883 81.9646 76.6693C82.3997 76.1468 82.4867 75.5372 82.2256 75.0148Z",
    fill: "#05446A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2482_1281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.8,
    height: 76.8,
    fill: "white",
    transform: "translate(9.59985 19.2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProfilePictureCustomBlue);
export default __webpack_public_path__ + "static/media/NoProfilePictureCustomBlue.00db96752e687d3942a2f597071f52d4.svg";
export { ForwardRef as ReactComponent };